import { styled } from '@goodfynd/theme';

export const StyledChart = styled('section', {
  minWidth: '100%',
});

export const StyledColumnLeft = styled('div', {
  borderRight: '1px solid $Neutral05',
  paddingRight: 16,
});

export const StyledColumnRight = styled('div', {
  paddingLeft: 8,
});
